/** Scope worksheet sections — toggles control visibility per quote. */

export const SECTION_IDS = [
    "context",
    "cam",
    "robotics",
    "time_travel",
    "materials",
    "planning",
    "software",
    "customer_assets",
    "notes",
];

export const DEFAULT_SECTION_FLAGS = {
    context: true,
    cam: false,
    robotics: false,
    time_travel: false,
    materials: false,
    planning: false,
    software: false,
    customer_assets: false,
    notes: true,
};

export const SECTION_META = {
    context: {
        label: "Shop context",
        shortLabel: "Context",
        fields: ["shop_type"],
    },
    cam: {
        label: "Machining / CAM",
        shortLabel: "CAM",
        fields: ["machining_cam_consult"],
    },
    robotics: {
        label: "Robotics",
        shortLabel: "Robotics",
        fields: ["robot_implementation"],
    },
    time_travel: {
        label: "Time & travel",
        shortLabel: "Time / travel",
        fields: ["estimated_time", "travel"],
    },
    materials: {
        label: "Materials & supply",
        shortLabel: "Materials",
        fields: ["materials_needed", "customer_material_actions"],
    },
    planning: {
        label: "Planning",
        shortLabel: "Planning",
        fields: ["scheduling_planning"],
    },
    software: {
        label: "Software",
        shortLabel: "Software",
        fields: ["software_requirements"],
    },
    customer_assets: {
        label: "Customer assets",
        shortLabel: "On-site equip.",
        fields: ["customer_equipment"],
    },
    notes: {
        label: "Notes & exclusions",
        shortLabel: "Notes",
        fields: ["other_notes"],
    },
};

export function inferSectionFlagsFromForm(form) {
    const flags = { ...DEFAULT_SECTION_FLAGS };
    for (const id of SECTION_IDS) {
        const meta = SECTION_META[id];
        const hasContent = meta.fields.some((f) => String(form?.[f] || "").trim());
        if (hasContent) flags[id] = true;
    }
    return flags;
}

export function parseSectionFlags(raw, form) {
    if (raw != null && String(raw).trim()) {
        try {
            const parsed = JSON.parse(raw);
            if (parsed && typeof parsed === "object") {
                const out = { ...DEFAULT_SECTION_FLAGS };
                for (const id of SECTION_IDS) {
                    if (typeof parsed[id] === "boolean") out[id] = parsed[id];
                }
                return out;
            }
        } catch {
            /* fall through */
        }
    }
    return inferSectionFlagsFromForm(form);
}

export function serializeSectionFlags(flags) {
    const out = {};
    for (const id of SECTION_IDS) {
        out[id] = Boolean(flags?.[id]);
    }
    return JSON.stringify(out);
}
